// extracted by mini-css-extract-plugin
module.exports = {"loadingIndicator":"room__style__loadingIndicator___329VnB","spin":"room__style__spin___3TPdNv","isDark":"room__style__isDark___1Exlvr"};